import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { GRADIENT_COLORS } from "./settings";
import { GRADIENT_COLORS_DARK } from "./settings";
import TabIcon from "./Media/sadi.png"; // neues Tab-Icon (PNG)

// dynamisch CSS-Variablen setzen
const root = document.documentElement;
// Setze beide Variablen unabhängig vom aktuellen Modus:
root.style.setProperty("--gradient-color-1", GRADIENT_COLORS[0]);
root.style.setProperty("--gradient-color-2", GRADIENT_COLORS[1]);
root.style.setProperty("--gradient-color-1-dark", GRADIENT_COLORS_DARK[0]);
root.style.setProperty("--gradient-color-2-dark", GRADIENT_COLORS_DARK[1]);

// Setze den Browser-Tab Titel
document.title = "Sarahnokumo Streamplan";

// Favicon setzen/ersetzen
(function applyFavicon(iconUrl) {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.type = "image/png";
  link.href = iconUrl;
})(TabIcon);

const container = document.getElementById("root");
const rootNode = ReactDOM.createRoot(container);
rootNode.render(<App />);
